import { linkConfigPro } from "../config"
import { langId } from "../languages"

const useFeatureStory = () => {
  return linkConfigPro.filter(link => link.title === langId.FEATURE_STORIES)[0]
}

export default useFeatureStory
